
<kendo-dialog class='scroll'
              [height]="(afUiWin.calculatedHeightLarge | async)!"
              [width]="(afUiWin.calculatedWidthMedium | async)!"
              [title]="'System Log Details'"
              (close)="this.cancel.emit()">

  <div kendoDialogBody>

    <div class="isg-log-system-editor-formwrapper">

      <label class="label-small" for="loggedOn">Created On:</label>
      <div id="loggedOn" class="isg-form-value-emphasis">{{data.loggedOn| utcToLocal }}</div>

      <label class="label-small" for="loggedBy">Logged By:</label>
      <div id="loggedBy">{{data.loggedBy}}</div>

      <label class="label-small" for="severity">Severity:</label>
      <div id="severity" [ngClass]="getSeverityClass(data.severity)">{{data.severity??"-"}}</div>

      <label class="label-small" for="logid">Log Id:</label>
      <div id="logid">{{data.id??"-"}}</div>

      <label class="label-small" for="categoryName">Category:</label>
      <div id="categoryName">{{data.categoryName??"-"}}</div>

      <label class="label-small" for="eventid">Event Id:</label>
      <div id="eventid">{{data.eventid??"-"}}</div>

      <label class="label-small" for="source">Source:</label>
      <div id="source">{{data.source??"-"}}</div>

      <label class="label-small" for="subSource">SubSource:</label>
      <div id="subSource">{{data.subSource??"-"}}</div>

      <label class="label-small" for="Message">Message:</label>
      <textarea id="Message" name="Message" class="form-control" rows="2">{{data.message}}</textarea>

      <label class="label-small" for="Detail">Detail:</label>
      <textarea id="Detail" name="Detail" class="form-control" rows="3">{{data.detail}}</textarea>

      <label class="label-small" for="Exception">Exception:</label>
      <textarea id="Exception" name="Exception" class="form-control" rows="2">{{data.exception}}</textarea>

      <label class="label-small" for="Stack">Stack:</label>
      <textarea id="Stack" name="Stack" class="form-control" rows="2">{{data.stacktrace}}</textarea>

      <label class="label-small" for="extensions">Extensions:</label>
      <textarea id="extensions" name="extensions" class="form-control" rows="2">{{data.extensions}}</textarea>

    </div>

  </div>

  <ng-template kendoDialogActions>
    <button kendoButton [primary]="true">Close</button>
  </ng-template>

</kendo-dialog>
